import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import Loading from '../../ui/Loading.js'

class PeriodoPresupuestarioReglasAbm extends Component {
    constructor(props) {
        super(props)
        const regla = props.regla || null
        this.state = {
            loading: false,
            formData: {
                nombre:              regla ? regla.nombre              : '',
                porcentaje_umbral:   regla ? String(regla.porcentaje_umbral) : '',
                accion_notificacion: regla ? Boolean(regla.accion_notificacion) : false,
                accion_bloqueo:      regla ? Boolean(regla.accion_bloqueo)      : false,
                activa:              regla ? Boolean(regla.activa)              : true,
            },
            errors: {},
        }
        this.handleInputChange    = this.handleInputChange.bind(this)
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this)
        this.handleToggleActiva   = this.handleToggleActiva.bind(this)
        this.handleSubmit         = this.handleSubmit.bind(this)
    }

    handleInputChange(e) {
        var name  = e.target.name
        var value = e.target.value
        var formData = Object.assign({}, this.state.formData)
        formData[name] = value
        var errors = Object.assign({}, this.state.errors)
        delete errors[name]
        this.setState({ formData: formData, errors: errors })
    }

    handleCheckboxChange(e) {
        var name    = e.target.name
        var checked = e.target.checked
        var formData = Object.assign({}, this.state.formData)
        formData[name] = checked
        var errors = Object.assign({}, this.state.errors)
        delete errors['acciones']
        this.setState({ formData: formData, errors: errors })
    }

    handleToggleActiva() {
        var formData = Object.assign({}, this.state.formData)
        formData.activa = !formData.activa
        this.setState({ formData: formData })
    }

    validate() {
        var errors   = {}
        var formData = this.state.formData
        var intl     = this.props.intl

        if (!formData.nombre || !formData.nombre.trim()) {
            errors.nombre = intl.formatMessage({ id: 'periodoPresupuestarioReglas.form.error.nombre_requerido', defaultMessage: 'El nombre es requerido.' })
        }

        if (!formData.porcentaje_umbral || formData.porcentaje_umbral === '') {
            errors.porcentaje_umbral = intl.formatMessage({ id: 'periodoPresupuestarioReglas.form.error.porcentaje_requerido', defaultMessage: 'El porcentaje es requerido.' })
        } else {
            var pct = Number(formData.porcentaje_umbral)
            if (!Number.isInteger(pct) || pct < 1 || pct > 100) {
                errors.porcentaje_umbral = intl.formatMessage({ id: 'periodoPresupuestarioReglas.form.error.porcentaje_invalido', defaultMessage: 'Ingresá un valor entero entre 1 y 100.' })
            }
        }

        if (!formData.accion_notificacion && !formData.accion_bloqueo) {
            errors.acciones = intl.formatMessage({ id: 'periodoPresupuestarioReglas.form.error.accion_requerida', defaultMessage: 'Seleccioná al menos una acción.' })
        }

        return errors
    }

    handleSubmit(e) {
        e.preventDefault()
        var errors = this.validate()
        if (Object.keys(errors).length > 0) {
            this.setState({ errors: errors })
            return
        }
        if (this.props.onSave) {
            var component = this
            var result = this.props.onSave(this.state.formData)
            if (result && typeof result.then === 'function') {
                component.setState({ loading: true })
                result.finally(function() { component.setState({ loading: false }) })
            }
        }
    }

    render() {
        var formData = this.state.formData
        var errors   = this.state.errors
        var loading  = this.state.loading
        var isEdit   = Boolean(this.props.regla)

        return (
            <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1" role="dialog">
                <div className="modal-dialog" role="document" style={{ maxWidth: 520, marginTop: 60 }}>
                    <div className="modal-content">
                        <div className="modal-header bg-fleet">
                            <h4 className="modal-title text-white">
                                {isEdit
                                    ? <FormattedMessage id="periodoPresupuestarioReglas.modal.titulo_editar" defaultMessage="Editar Regla" />
                                    : <><i className="ft-plus mr-1"></i><FormattedMessage id="periodoPresupuestarioReglas.modal.titulo_crear" defaultMessage="Nueva Regla" /></>
                                }
                            </h4>
                            <button type="button" className="close text-white" onClick={this.props.onCancel} aria-label="Cerrar">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <form onSubmit={this.handleSubmit} noValidate>
                            <div className="modal-body" style={{ padding: '24px 28px' }}>
                                {loading && <Loading />}

                                {/* Nombre */}
                                <div className="form-group">
                                    <label className="col-form-label">
                                        <FormattedMessage id="periodoPresupuestarioReglas.form.nombre" defaultMessage="Nombre" />
                                        {' '}<span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={'form-control' + (errors.nombre ? ' is-invalid' : '')}
                                        name="nombre"
                                        value={formData.nombre}
                                        placeholder={this.props.intl.formatMessage({ id: 'periodoPresupuestarioReglas.form.nombre_placeholder', defaultMessage: 'Ej. Alerta Temprana 80%' })}
                                        onChange={this.handleInputChange}
                                    />
                                    {errors.nombre && <div className="invalid-feedback">{errors.nombre}</div>}
                                </div>

                                {/* % Umbral */}
                                <div className="form-group">
                                    <label className="col-form-label">
                                        <FormattedMessage id="periodoPresupuestarioReglas.form.porcentaje" defaultMessage="% Umbral" />
                                        {' '}<span className="text-danger">*</span>
                                    </label>
                                    <div className="input-group">
                                        <input
                                            type="number"
                                            className={'form-control' + (errors.porcentaje_umbral ? ' is-invalid' : '')}
                                            name="porcentaje_umbral"
                                            value={formData.porcentaje_umbral}
                                            min="1"
                                            max="100"
                                            placeholder="0"
                                            onChange={this.handleInputChange}
                                        />
                                        <div className="input-group-append">
                                            <span className="input-group-text">%</span>
                                        </div>
                                        {errors.porcentaje_umbral && <div className="invalid-feedback d-block">{errors.porcentaje_umbral}</div>}
                                    </div>
                                    <small className="form-text text-muted">
                                        <FormattedMessage id="periodoPresupuestarioReglas.form.porcentaje_hint" defaultMessage="Ingresá un valor entre 1 y 100" />
                                    </small>
                                </div>

                                {/* Acciones */}
                                <div className="form-group">
                                    <label className="col-form-label">
                                        <FormattedMessage id="periodoPresupuestarioReglas.form.acciones" defaultMessage="Acciones" />
                                        {' '}<span className="text-danger">*</span>
                                    </label>
                                    <div className="d-flex" style={{ gap: 10 }}>
                                        <label
                                            className="d-flex align-items-center mb-0 rounded"
                                            style={{
                                                cursor: 'pointer', fontWeight: 'normal', flex: 1,
                                                border: formData.accion_notificacion ? '2px solid rgba(36,27,62,0.35)' : '1px solid #e3ebf3',
                                                padding: formData.accion_notificacion ? '11px 11px' : '12px',
                                                gap: 12,
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                name="accion_notificacion"
                                                checked={formData.accion_notificacion}
                                                onChange={this.handleCheckboxChange}
                                                style={{ margin: 0, flexShrink: 0 }}
                                            />
                                            <i className="fa fa-bell text-warning" style={{ fontSize: 22, flexShrink: 0 }}></i>
                                            <span>
                                                <strong style={{ display: 'block', fontSize: 13 }}>
                                                    <FormattedMessage id="periodoPresupuestarioReglas.form.accion.notificacion" defaultMessage="Notificación" />
                                                </strong>
                                                <small className="text-muted">
                                                    <FormattedMessage id="periodoPresupuestarioReglas.form.accion.notificacion_desc" defaultMessage="Envía una alerta" />
                                                </small>
                                            </span>
                                        </label>
                                        <label
                                            className="d-flex align-items-center mb-0 rounded"
                                            style={{
                                                cursor: 'pointer', fontWeight: 'normal', flex: 1,
                                                border: formData.accion_bloqueo ? '2px solid rgba(36,27,62,0.35)' : '1px solid #e3ebf3',
                                                padding: formData.accion_bloqueo ? '11px 11px' : '12px',
                                                gap: 12,
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                name="accion_bloqueo"
                                                checked={formData.accion_bloqueo}
                                                onChange={this.handleCheckboxChange}
                                                style={{ margin: 0, flexShrink: 0 }}
                                            />
                                            <i className="fa fa-ban text-danger" style={{ fontSize: 22, flexShrink: 0 }}></i>
                                            <span>
                                                <strong style={{ display: 'block', fontSize: 13 }}>
                                                    <FormattedMessage id="periodoPresupuestarioReglas.form.accion.bloqueo" defaultMessage="Bloqueo" />
                                                </strong>
                                                <small className="text-muted">
                                                    <FormattedMessage id="periodoPresupuestarioReglas.form.accion.bloqueo_desc" defaultMessage="Restringe el acceso" />
                                                </small>
                                            </span>
                                        </label>
                                    </div>
                                    {errors.acciones && <div className="text-danger mt-1" style={{ fontSize: '0.875em' }}>{errors.acciones}</div>}
                                </div>

                                {/* Estado */}
                                <div className="form-group">
                                    <label className="col-form-label">
                                        <FormattedMessage id="periodoPresupuestarioReglas.form.estado" defaultMessage="Estado" />
                                    </label>
                                    <div className="d-flex align-items-center" style={{ gap: 10 }}>
                                        <div
                                            onClick={this.handleToggleActiva}
                                            style={{
                                                width: 44, height: 24, borderRadius: 12, cursor: 'pointer',
                                                backgroundColor: formData.activa ? '#28a745' : '#ccc',
                                                position: 'relative', transition: 'background 0.2s', flexShrink: 0,
                                            }}
                                        >
                                            <div style={{
                                                width: 18, height: 18, borderRadius: '50%', backgroundColor: '#fff',
                                                position: 'absolute', top: 3,
                                                left: formData.activa ? 23 : 3,
                                                transition: 'left 0.2s',
                                            }} />
                                        </div>
                                        <span className={formData.activa ? 'text-success' : 'text-muted'}>
                                            <FormattedMessage id="periodoPresupuestarioReglas.form.activa" defaultMessage="Activa" />
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer flex-column align-items-stretch">
                                {this.props.error && (
                                    <div className="alert alert-danger w-100 mb-2 py-2" role="alert" style={{ fontSize: 13 }}>
                                        {this.props.error}
                                    </div>
                                )}
                                <div className="d-flex justify-content-end" style={{ gap: 8 }}>
                                <button type="button" className="btn btn-danger" onClick={this.props.onCancel}>
                                    <i className="fa fa-times-circle mr-1"></i>
                                    <FormattedMessage id="periodoPresupuestarioReglas.modal.cancelar" defaultMessage="Cancelar" />
                                </button>
                                <button type="submit" className="btn btn-primary" disabled={loading}>
                                    <i className="ft-check mr-1"></i>
                                    {isEdit
                                        ? <FormattedMessage id="periodoPresupuestarioReglas.modal.guardar" defaultMessage="Guardar" />
                                        : <FormattedMessage id="periodoPresupuestarioReglas.modal.crear" defaultMessage="Guardar" />
                                    }
                                </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

export default injectIntl(PeriodoPresupuestarioReglasAbm)
